import type { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';

import { CollectionsIcon, RbPricesIcon } from './icons';
import { SidebarSectionHeader } from './Sidebar.styles';
import { SidebarItem } from './SidebarItem';
import { RequirePermission } from '../../auth';
import { Routes } from '../../routes/routes';

/** «Витрина» sidebar section (AUT-1013): «Коллекции» and «Цены РБ», `manage_settings`. */
export const SidebarVitrine = (): ReactElement => {
  const { t } = useTranslation();
  return (
    <RequirePermission perm="manage_settings" fallback={null}>
      <SidebarSectionHeader>{t('nav.sections.vitrine')}</SidebarSectionHeader>
      <SidebarItem
        to={Routes.App.VitrineCollections}
        icon={<CollectionsIcon />}
        label={t('nav.vitrineCollections')}
      />
      <SidebarItem
        to={Routes.App.VitrineRbPrices}
        icon={<RbPricesIcon />}
        label={t('nav.vitrineRbPrices')}
      />
    </RequirePermission>
  );
};
